import React from "react";
import PropTypes from "prop-types";

// Styles
import styles from "./styles.module.css";

const SectionSeparator = ({ children }) => {
	return <div className={styles.separator}>{children}</div>;
};

SectionSeparator.propTypes = {
	children: PropTypes.node.isRequired,
};

export default SectionSeparator;
